import React, { createContext, forwardRef, useRef } from 'react';
import { testIdGen } from '../../utils/index.js';
import { ControlGroup } from '../ControlGroup/index.js';
import { noop } from '../../utils/noop.js';
export const RadioGroupContext = createContext({
    name: '',
    onChange: noop
});
/**
 * Group radios together into a field.
 */
export const RadioGroup = forwardRef((props, ref) => {
    const { children, dataMetrics, dataTestId, defaultValue, addClassName, disabled, readOnly, onChange, name, value, horizontal, ...rest } = props;
    const group1Ref = useRef(null);
    const handleKeyPress = (e) => {
        if (e.key === 'Tab') {
            const radios = [...(group1Ref.current?.querySelectorAll('input[type="radio"]') || [])];
            const currentIndex = radios?.findIndex((radio) => radio === document.activeElement);
            if (currentIndex !== -1) {
                const shiftKey = e.shiftKey ? -1 : 1;
                let nextIndex = currentIndex + shiftKey;
                let newIndex = (nextIndex + radios?.length) % radios?.length;
                let radio = radios[newIndex];
                while (radio.hasAttribute('disabled') && nextIndex >= 0 && nextIndex < radios?.length) {
                    nextIndex = newIndex + shiftKey;
                    newIndex = (nextIndex + radios?.length) % radios?.length;
                    radio = radios[newIndex];
                }
                radio?.focus();
                if (nextIndex >= 0 && nextIndex < radios?.length) {
                    e.preventDefault();
                }
            }
        }
    };
    return (React.createElement(RadioGroupContext.Provider, { value: {
            defaultValue,
            disabled,
            readOnly,
            name,
            onChange,
            ref,
            value
        } },
        React.createElement("span", { onKeyDown: handleKeyPress, ref: group1Ref },
            React.createElement(ControlGroup, { addClassName: addClassName, "data-metrics": dataMetrics, "data-testid": dataTestId || `radio-group-${testIdGen(name)}`, horizontal: horizontal, role: "radiogroup", ...rest }, children))));
});
RadioGroup.displayName = 'RadioGroup';
//# sourceMappingURL=RadioGroup.js.map